<template>
  <div>
    <van-button class="value" @click="show=true" size="small">
      <span v-if="$attrs.value">
        {{ typeof $attrs.value === 'object' ? $attrs.value.format('yyyy-MM-dd') : $attrs.value }}
      </span>
      <span v-else style="color: orange">请选择</span>
    </van-button>
    <van-popup v-model="show" position="bottom" style=" height: 60%">
      <van-datetime-picker :value="$attrs.value ? new Date($attrs.value) : new Date()"
                           type="date"
                           title="选择日期"
                           @confirm="confirm"
                           @cancel="cancel">
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
import { Cascader, Button, Popup, DatetimePicker } from 'vant'

export default {
  name: 'WxDateSelect',
  components: {
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker
  },
  data () {
    return { show: false }
  },
  methods: {
    confirm (value) {
      this.$emit('input', value)
      this.show = false
    },
    cancel () {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
